import { ComponentType, lazy } from 'react';

/**
 * React.lazy for a page module's named export, e.g.
 * `lazyPage(() => import('./pages/users/page'), 'Users')`.
 */
export const lazyPage = <M extends Record<K, ComponentType>, K extends keyof M>(
  load: () => Promise<M>,
  name: K
) =>
  lazy(() =>
    load().then((module) =>
      // undefined when the vite:preloadError handler in main.tsx has
      // cancelled a failed load and is reloading the page: keep the
      // Suspense spinner up rather than flashing an error.
      module
        ? { default: module[name] }
        : new Promise<{ default: ComponentType }>(() => {})
    )
  );
